<template>
    <div v-loading="loading">
        <div ref="customerSaleChart" :style="{ height: map_height, width: '100%' }"></div>
    </div>
</template>
  
<script>
import OrderCount from "~/services/OrderCount";
import echarts from "echarts";

export default {
    props:{
        params:{
            type: Object,
            required: true,
        },
        map_height:{
            type: String,
            default: '385px',
        }
    },
    data() {
        return {
            loading: false,
            count_data: null,
        };
    },
    created(){
        this.getData(this.params);
    },
    mounted() {
        
    },
    methods: {
        getData(params) {
            this.loading = true;
            OrderCount.getCustomerSale(params).then((res) => {
                if (res.code == 0) {
                    //初始化地图
                    this.count_data = res.data;
                    this.initChart();
                }
                this.loading = false;
            })
            .catch((err) => {
                console.error(err);
                this.loading = false;
            });
        },
        initChart() {
            if (!this.count_data) {
                return false;
            }
            const chartContainer = this.$refs.customerSaleChart;
            if (!chartContainer){
                return false;
            }
            const myChart = echarts.init(chartContainer);
            const option = {
                color: [
                    "#5470c6",
                    "#91cc75",
                    "#fac858",
                    "#ee6666",
                    "#73c0de",
                    "#3dac78",
                ],
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b} : {c}'
                },
                series: [
                    {
                        name: '',
                        type: 'funnel',
                        left: '10%',
                        top: 60,
                        bottom: 60,
                        width: '70%',
                        min: 0,
                        max: this.count_data.bind_customer_num > 0 ? this.count_data.bind_customer_num : 20,
                        minSize: '0%',
                        maxSize: '100%',
                        sort: 'none',
                        gap: 2,
                        labelLine: {
                            length: 10,
                            lineStyle: {
                                width: 1,
                                type: 'solid'
                            }
                        },
                        itemStyle: {
                            borderColor: '#fff',
                            borderWidth: 1
                        },
                        emphasis: {
                            label: {
                                fontSize: 20
                            }
                        },
                        data: [
                            { value: this.count_data.bind_customer_num, name: '绑定客户' },
                            { value: this.count_data.try_out_customer_num, name: '开通试用客户' },
                            { value: this.count_data.deep_trial_customer_num, name: '有效试用客户' },
                            { value: this.count_data.deal_customer_num, name: '成交客户' },
                        ]
                    }
                ]
            };
            myChart.setOption(option);
        },
    },
};
</script>
  
<style>
/* 在这里添加样式 */
</style>
  


// WEBPACK FOOTER //
// src/views/count/echarts/customerSaleChart.vue